import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import fiCommon from "./locales/fi/common.json";
import fiEtusivu from "./locales/fi/etusivu.json";
import fiOikeusbanneri from "./locales/fi/oikeusbanneri.json"; // ← add
import enCommon from "./locales/en/common.json";
import enEtusivu from "./locales/en/etusivu.json";
import enOikeusbanneri from "./locales/en/oikeusbanneri.json"; // ← add
import fiSideNav from "./locales/fi/sideNav.json";
import enSideNav from "./locales/en/sideNav.json";
import fiTukipyyntoLista from "./locales/fi/tukipyyntoLista.json";
import enTukipyyntoLista from "./locales/en/tukipyyntoLista.json";
import fiKayttajaLista from "./locales/fi/kayttajaLista.json";
import enKayttajaLista from "./locales/en/kayttajaLista.json";
import fiRaportit from "./locales/fi/raportit.json";
import enRaportit from "./locales/en/raportit.json";
import fiTukipyyntoNakyma from "./locales/fi/tukipyyntoNakyma.json";
import enTukipyyntoNakyma from "./locales/en/tukipyyntoNakyma.json";
import fiKayttajaSideBar from "./locales/fi/kayttajaSideBar.json";
import enKayttajaSideBar from "./locales/en/kayttajaSideBar.json";
import fiKayttajaKortti from "./locales/fi/kayttajaKortti.json";
import enKayttajaKortti from "./locales/en/kayttajaKortti.json";
import fiLaitteet from "./locales/fi/laitteet.json";
import enLaitteet from "./locales/en/laitteet.json";
import fiOikeudet from "./locales/fi/oikeudet.json";
import enOikeudet from "./locales/en/oikeudet.json";
import fiVirkailijanLisays from "./locales/fi/virkailijanLisays.json";
import enVirkailijanLisays from "./locales/en/virkailijanLisays.json";
import fiTodentaminen from "./locales/fi/todentaminen.json";
import enTodentaminen from "./locales/en/todentaminen.json";
import fiManuaaliProsessi from "./locales/fi/manuaaliprosessi.json";
import enManuaaliProsessi from "./locales/en/manuaaliprosessi.json";
import fiTodennusValinta from "./locales/fi/todennusValinta.json";
import enTodennusValinta from "./locales/en/todennusValinta.json";

export const resources = {
  en: {
    common: enCommon,
    etusivu: enEtusivu,
    oikeusbanneri: enOikeusbanneri,
    sideNav: enSideNav,
    tukipyyntoLista: enTukipyyntoLista,
    tukipyyntoNakyma: enTukipyyntoNakyma,
    kayttajaLista: enKayttajaLista,
    raportit: enRaportit,
    kayttajaSideBar: enKayttajaSideBar,
    kayttajaKortti: enKayttajaKortti,
    laitteet: enLaitteet,
    oikeudet: enOikeudet,
    virkailijanLisays: enVirkailijanLisays,
    todentaminen: enTodentaminen,
    manuaaliProsessi: enManuaaliProsessi,
    todennusValinta: enTodennusValinta,
  },
  fi: {
    common: fiCommon,
    etusivu: fiEtusivu,
    oikeusbanneri: fiOikeusbanneri,
    sideNav: fiSideNav,
    tukipyyntoLista: fiTukipyyntoLista,
    tukipyyntoNakyma: fiTukipyyntoNakyma,
    kayttajaLista: fiKayttajaLista,
    raportit: fiRaportit,
    kayttajaSideBar: fiKayttajaSideBar,
    kayttajaKortti: fiKayttajaKortti,
    laitteet: fiLaitteet,
    oikeudet: fiOikeudet,
    virkailijanLisays: fiVirkailijanLisays,
    todentaminen: fiTodentaminen,
    manuaaliProsessi: fiManuaaliProsessi,
    todennusValinta: fiTodennusValinta,
  },
} as const;
i18n.use(initReactI18next).init({
  resources,
  fallbackLng: "fi",
  supportedLngs: ["fi", "en"],
  ns: [
    "common",
    "etusivu",
    "oikeusbanneri",
    "sideNav",
    "tukipyyntoLista",
    "kayttajaLista",
    "tukipyyntoNakyma",
    "kayttajaSideBar",
    "kayttajaKortti",
    "laitteet",
    "oikeudet",
    "virkailijanLisays",
    "todentaminen",
    "manuaaliProsessi",
    "todennusValinta",
  ],
  defaultNS: "common",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
